import React, { useState, useEffect, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { numberFormatter } from '../../dynamic/numberFormatter';

import { DataContext } from '../../init/getData';
import { FcPortraitMode, FcAbout } from "react-icons/fc";
import { datePrintFormatter } from '../../dynamic/dateFormatter'; 
import print from '../print/print';

import { Button } from 'antd';

const CartModal = (props) => {

  const { userData, settingData, serverApi, localApi, devData } = useContext(DataContext);

  const userName = userData.name;  

  let api;
  if (!devData?.isServer && !devData?.isCloud) {
    api = serverApi;
  } else {
    api = localApi;
  }

  const { showModal, toggleModal, idRow, refreshTable, createdBy } = props;

  const [loadingEffect, setLoadingEffect] = useState(false);

  const cart = idRow?.cart;

  const printCart = () => {

   



    let printData = {
      userName: userName,
      settingData: settingData,
      price: idRow?.usd,
      date: new Date().toISOString().split('T')[0],
      invoiceId: idRow?.id,
      className: idRow?.class?.name,
      registrationDate: idRow?.registrationDate,
      expiryDate: idRow?.expiryDate,

    }
    print(printData);
  }

  return (
    <Modal show={showModal} backdrop="static" size='xl' onHide={toggleModal}>
      <Modal.Header style={{ background: "#39aaa5", display: "flex", justifyContent: "center" }}>
        <div>
          <Modal.Title style={{ color: "white" }}> Membership ID :  {idRow.id}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>

        <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '4%', marginTop: '2%' }}>
          <div className='card' style={{ alignItems: 'center', textAlign: 'center', width: '40%' }}>
            <FcAbout size={45} style={{ marginBottom: '1%' }} />
            <h6>Created At: {datePrintFormatter(idRow.createdAt)}</h6>
            <h6>Created By: {createdBy ? createdBy : 'N/A'}</h6>
 
          </div>
        </div>

        <table style={{ width: '100%', borderCollapse: 'collapse', borderColor: '#39aaa5' }} className="table "> 
          <thead style={{ background: '#39aaa5', color: 'white', lineHeight: 0.5 }}>
            <tr>
              <th style={{minWidth: '150px', textAlign: 'left' }}>Barcode</th>
              <th style={{ minWidth: '150px', textAlign: 'left' }}>Class</th>
              <th style={{ minWidth: '150px', textAlign: 'left' }}>Trainer</th>
              <th style={{ minWidth: '150px', textAlign: 'left' }}>Price</th>
              <th style={{ minWidth: '150px', textAlign: 'left' }}>Registration Date</th> 
              <th style={{ minWidth: '150px', textAlign: 'left' }}>Expiry Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ minWidth: '150px', textAlign: 'left' }}>{idRow?.member?.barcode || 'N/A'}</td>
              <td style={{ minWidth: '150px', textAlign: 'left' }}>{idRow?.class?.name || 'N/A'}</td>
              <td style={{ minWidth: '150px', textAlign: 'left' }}>{idRow?.trainer?.name || 'N/A'}</td>
              <td style={{ minWidth: '150px', textAlign: 'left' }}>{numberFormatter(idRow?.classPrice, 2) || '0.00'}</td>
              <td style={{ minWidth: '150px', textAlign: 'left' }}>{idRow?.registrationDate}</td>
              <td style={{ minWidth: '150px', textAlign: 'left' }}>{idRow?.expiryDate}</td>
            </tr>
          </tbody>
        </table>

     


        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      
          <div style={{ display: 'flex', gap: '10px' }}>
            <button type="button" className="btn btn-secondary" style={{ backgroundColor: '#1f2937' }} onClick={toggleModal}>Close</button>
            <button type="button" style={{ backgroundColor: '#1d7790' }} className="btn btn-primary" onClick={printCart}>Print</button>
          </div>
        </div>


      </Modal.Body>

    </Modal>
  );
};

export default CartModal;
